import { render, staticRenderFns } from "./ActivityStaticFields.vue?vue&type=template&id=328fec49"
import script from "./ActivityStaticFields.vue?vue&type=script&lang=js"
export * from "./ActivityStaticFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports